import { useState } from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../App.css';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import GreenGreyLightIcon from '../../components/GreenGreyLightIcon';
import RedGreyLightIcon from '../../components/RedGreyLightIcon';
import { Styles, StyleConstants } from '../../Styles';
import Box from '@mui/material/Box';
import PaginationComponent from '../../components/PaginationComponent';
import { Stack } from '@mui/material';

const CarTractionSystemTab = (props) => {
    const { packet, car } = props;

    const [page, setPage] = useState(1);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <>
            {(packet.board2 !== null) && (
                <Stack direction="column">
                    <TableContainer component={Paper} sx={{ height: 'calc(100% - 40px)' }}>
                        <Table size='small' sx={{ border: '3px solid ' + StyleConstants.borderColor }}>
                            <TableHead>
                                <TableRow sx={{ '& th': { color: '#FFFFFF', backgroundColor: StyleConstants.mainBgColor } }}>
                                    <TableCell sx={{ ...Styles.carCell }}>
                                        Traction System (VVVF)
                                    </TableCell>
                                    <TableCell sx={{ ...Styles.carBorderCell, width: '230px' }}>
                                        Unit 1
                                    </TableCell>
                                    <TableCell sx={{ ...Styles.carBorderCell, width: '230px' }}>
                                        Unit 2
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {page && (page === 1) && (
                                    <>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Energy Consumption for Powering (kWh) (1kWh/pulse)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCellRight}>
                                                {car.vvvf1Powering}
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCellRight}>
                                                {car.vvvf2Powering}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Energy Consumption for Braking (kWh) (1kWh/pulse)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCellRight}>
                                                {car.vvvf1Braking}
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCellRight}>
                                                {car.vvvf2Braking}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Safety Command (S)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.safetyCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.safetyCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Driving Command (P)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.drivingCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.drivingCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Braking Command (B)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.brakingCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.brakingCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Emergency Brake Command (EB)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf1.emerBrakeCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf2.emerBrakeCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Emergency Drive (ED)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf1.emerDrive} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf2.emerDrive} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                    </>
                                )}

                                {page && (page === 2) && (
                                    <>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Shunt Mode (SM)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.shuntMode} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.shuntMode} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Backward Command (R)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.backwardCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.backwardCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Forward Command (F)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.forwardCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.forwardCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                LS1 Close (LS1)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.ls1Close} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.ls1Close} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                LS2 Close (LS2)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.ls2Close} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.ls2Close} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Another Inverter Line Switch Close (LSA)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.anInvLineSwClose} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.anInvLineSwClose} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                HB On (HB)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf1.hbOn} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf2.hbOn} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                    </>
                                )}

                                {page && (page === 3) && (
                                    <>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Another Inverter Fault (D20F)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf1.anInvFault} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <RedGreyLightIcon onOffBit={packet.board2.vvvf2.anInvFault} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Power Supply Emergency Drive (PED)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.powerSupplyEmerDrive} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.powerSupplyEmerDrive} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Gradient Command (G)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.gradientCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.gradientCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Disc Brake Supervisory (DBS)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.discBrakeSupervisory} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.discBrakeSupervisory} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                LS1 On (LONR)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.ls1On} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.ls1On} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                LS2 On (LBTR)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.ls2On} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.ls2On} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Another Inverter Disconnect (MCOR2)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.anInvDiscon} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.anInvDiscon} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                    </>
                                )}

                                {page && (page === 4) && (
                                    <>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                HB on Command (HBR)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.hbOnCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.hbOnCom} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Holding Brake On (SBR)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.holdBrakeOn} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.holdBrakeOn} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Electric Brake Available Signal (CDR)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.electBrakeAvaSignal} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.electBrakeAvaSignal} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Sanding (SDR)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.sand} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.sand} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                Reset by Command Off (RSR)
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf1.resetByComOff} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                <GreenGreyLightIcon onOffBit={packet.board2.vvvf2.resetByComOff} onLabel="Activated" offLabel="Inactive" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                            <TableCell sx={Styles.carCell}>
                                                
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                
                                            </TableCell>
                                            <TableCell sx={Styles.carBorderCell}>
                                                
                                            </TableCell>
                                        </TableRow>
                                    </>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ height: '40px', alignContent: 'center', alignItems: 'center', textAlign: 'center', color: Styles.fontColor }}>
                        <PaginationComponent
                            count={4}
                            page={page}
                            onChange={handleChange}
                        />
                    </Box>
                </Stack>
            )}
        </>
    );
};

export default CarTractionSystemTab;